import React from "react";
import { MainContainer, TextAboutTools, ReactLogoContainer, ReactLogo } from "./ToolsUsedStyles";
import { DiCss3 } from "react-icons/di";

export const ToolsUsed = () => (
    <div>
    <MainContainer style={{  }}>
        <TextAboutTools style={{ paddingRight: '0' }}>
            Tools used:
        </TextAboutTools>
        <TextAboutTools>
            ReactJS
        </TextAboutTools>
        <ReactLogoContainer style={{  }}>
            <ReactLogo />
        </ReactLogoContainer>
        <TextAboutTools>
            and CSS
        </TextAboutTools>
        <DiCss3 size = "2rem" color="#264de4"/><br />
    </MainContainer>
    <TextAboutTools>
        This website is currently under production <br /> and is being updated daily <br /> Thank you!
    </TextAboutTools>
    </div>
);

export default ToolsUsed;